export default{
    return_return:'回流',
    // daily
    return_dailyreturnusers:'每日回流用户',
    return_dailyreturnusersdetails:'每日回流用户表',
    return_dailyreturnusersTable:'日回流用户',
    return_dailyTableone:'日回流用户=日活跃-日留存-日新进',
    // weekly
    return_weeklyBiweeklyReturnUsers:'周/双周回流用户',
    return_weeklyReturnUsers:'周回流用户',
    return_biweeklyReturnUsers:'双周回流用户',
    return_weeklyBiweeklyReturnUsersDetail:'周/双周回流用户表',
    return_weeklyReturnUsersTable:'周回流用户',
    return_weeklytableoneTip:'周回流用户=周活跃-周留存-周新进',
    return_weeklyTabletwoTip:'双月回流用户=双月活跃-双月留存-双月新进',
    // monthly
    return_monthlyReturnUsers:'月回流用户',
    return_monthlyReturnUsersDetail:'月回流用户表',
    return_thisMonth:'本月回流',
    return_lastYear:'去年同期回流',
    
    return_data:'日期',
    return_countryregionzonebreakdown:'国家/区域/区服 排行榜',  
    return_returnoftop10zones:'回流用户 Top 10 区服',
    return_returnoftop10country:'回流用户 Top 10 国家',
    return_returnoftop10Regions:'回流用户 Top 10 区域',

    return_returnoftop10platform:'回流用户 平台',
    return_returnoftop10language:'回流用户 语言',

    

    return_sumreturn:'回流用户总数',
    return_shareofall:'全局占比',
    return_country:'国家',
    return_region:'区域',
    return_zone:'区服',
    return_system:'平台',
    return_language:'语言',
    return_records:'条记录',

    return_today:'当日',
    return_SDLW:'上周同期',
    return_Sum_Retrun:'回流用户'
}